import { createI18n, LocaleMessages, VueMessageType } from "vue-i18n";

function loadLocaleMessages(): LocaleMessages<VueMessageType> {
    const locales = require.context("@/locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages: LocaleMessages<VueMessageType> = {};
    locales.keys().forEach((path: string) => {
        let parts = path
            .split("/")
            .filter((p: string) => p !== ".")
            .map((p: string) => p.replace(".json", ""));

        const locale: string | undefined = parts.shift();
        if (!locale) return;

        if (parts.length === 0) {
            messages[locale] = locales(path).default;
        } else {
            messages[locale] = {
                ...((messages[locale] ?? {}) as Record<string, any>),
                ...createObject(parts, locales(path).default),
            };
        }
    });
    return messages;
}

function createObject(keys: string[], value: any): any {
    const currentKey = keys.shift();
    if (!currentKey) return value;
    return { [currentKey]: createObject(keys, value) };
}

function detectLanguage(): string | null {
    const messages = loadLocaleMessages();
    const langs = Object.getOwnPropertyNames(messages);
    return (
        langs.find((l) => l === navigator.language) ??
        langs.find((l) => l === navigator.language.split("-")[0]) ??
        null
    );
}

export default createI18n({
    legacy: false,
    locale: detectLanguage() ?? "en",
    fallbackLocale: "en",
    messages: loadLocaleMessages() as any,
});
